import styled from "@emotion/styled";
import {ReactComponent as svg} from "../../../../images/iconTSM.svg";

export const TSMSvg = styled(svg)`
    padding-top: 4px;
`;